import React from 'react';
import Card from '../../components/card.component';
import deniedIcon from '../../assets/images/iconos/icono-020.png';

const SUPPORT_EMAIL = 'soporte@diboxapp.com';

const AccessDenied = () => {
  return (
    <Card>
        <div className="access-denied-container">
            <div className="access-denied-box">
                <div className="denied-icon-box">
                    <img src={deniedIcon} className="img-fluid" />
                </div>
                <h4>Acceso denegado</h4>
                <p className="denied-text">
                    Su licencia actual no cuenta con el permiso necesario para realizar esta acción, 
                    si tiene alguna duda pongase en contacto con el servicio de soporte del sistema <span>{SUPPORT_EMAIL}</span>
                </p>
            </div>
        </div>
    </Card>
  )
}

export default AccessDenied;